<div class="confirmation-dialog-container">
    <h2 mat-dialog-title></h2>
    <mat-dialog-content>{{confirmationMsg}}</mat-dialog-content>
    <mat-dialog-actions align="center">
        <button
            tabindex="-1"
            mat-dialog-close
            mat-raised-button
            color="primary"
            class="mat-button-medium"
        >
            close
        </button>
    </mat-dialog-actions>
</div>
